import React from "react";
import styles from "../../styles.module.scss";
import { FaCopy } from "react-icons/fa";
import clsx from "clsx";
import { sleep } from "../../../../../libs/fns";

export default function CopyButton({
  className,
  ref,
}: {
  className?: string;
  ref: React.RefObject<HTMLDivElement | null>;
}) {
  const [open, setOpen] = React.useState(false);

  async function handleCopy() {
    if (!ref || !ref.current) return;

    await navigator.clipboard.writeText(ref.current.innerText);

    setOpen(true);

    await sleep(2);

    setOpen(false);
  }

  return (
    <div className={clsx(styles._onetouchai_buttonWrap, className)}>
      <button
        type="button"
        onClick={handleCopy}
        className={clsx(styles._onetouchai_toolButton, className)}
        disabled={open}
      >
        <FaCopy className={styles._onetouchai_icon} aria-label="コピー" />
      </button>
      {open && <div className={styles._onetouchai_popover}>コピーしました！</div>}
    </div>
  );
}
